import { render, staticRenderFns } from "./giftcard-pins.vue?vue&type=template&id=0a2c26d6"
import script from "./giftcard-pins.vue?vue&type=script&lang=js"
export * from "./giftcard-pins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports